import "../index.css";

const LoadingSpinner = () => {
  return <div className="loader"></div>;
};

export default LoadingSpinner;
